import { render, staticRenderFns } from "./ModalWithTrigger.vue?vue&type=template&id=040c0cc7&"
import script from "./ModalWithTrigger.vue?vue&type=script&lang=js&"
export * from "./ModalWithTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports